import { connect } from 'react-redux';
import { find, get } from 'lodash';

import { getCheckedOptionsMap, getSearchParameters } from '../../../../state';
import Facet from './Facet';
import {
    clearFacetOptions,
    selectFacetOption,
    checkFacetOption,
    uncheckFacetOption,
} from '../../../../actions/facets';
import {
    trackFacetChipClick,
    trackFilterClickAdditionalCriteria,
    trackFilterClickAvailability,
    trackFilterClickHospitalAffiliations,
    trackFilterClickLanguage,
    trackFilterClickSpecialHours,
    trackRefineSearchClickGender,
    trackRefineSearchClickProcedureDropdown,
} from '../../../../actions';

const mapStateToProps = (state, ownProps) => {
    const searchParameters = getSearchParameters(state);
    const checkedOptionsMap = getCheckedOptionsMap(state);
    const {
        displayName,
        facetId,
        options,
    } = ownProps;

    const appliedOptions = getAppliedOptions(facetId, searchParameters);
    const facetChipText = getFacetChipText(displayName, appliedOptions, options);
    const checkedOptions = getCheckedOptions(facetId, checkedOptionsMap, searchParameters);

    return {
        appliedOptions,
        checkedOptions,
        facetChipText,
        isActive: appliedOptions.length > 0,
    };
};

const mapDispatchToProps = (dispatch, { facetId }) => {
    const onApplyFacet = options => {
        const optionNames = options.map((option => option.displayName));
        let actionCreator;

        switch (facetId) {
            case 'languages':
                actionCreator = trackFilterClickLanguage;
                break;
            case 'sees_children':
                actionCreator = trackFilterClickAdditionalCriteria;
                break;
            case 'special_hours':
                actionCreator = trackFilterClickSpecialHours;
                break;
            case 'hospital_affiliations':
                actionCreator = trackFilterClickHospitalAffiliations;
                break;
            case 'sex':
                actionCreator = trackRefineSearchClickGender;
                break;
            case 'procedures':
                actionCreator = trackRefineSearchClickProcedureDropdown;
                break;
            case 'day_availability':
                actionCreator = trackFilterClickAvailability;
                break;
        }

        if (actionCreator) {
            dispatch(actionCreator(optionNames));
        }
    };

    return {
        onApplyFacet,
        onCheckOption: optionId => dispatch(checkFacetOption(facetId, optionId)),
        onClearOptions: () => dispatch(clearFacetOptions(facetId)),
        onClickFacetChip: () => dispatch(trackFacetChipClick(facetId)),
        onSelectOption: optionId => dispatch(selectFacetOption(facetId, optionId)),
        onUncheckOption: optionId => dispatch(uncheckFacetOption(facetId, optionId)),
    };
};

function getAppliedOptions(facetId, searchParameters) {
    const {
        filters,
        procedureId,
    } = searchParameters;

    if (facetId === 'procedures') {
        return [procedureId];
    } else {
        return filters[facetId] || [];
    }
}

export function getCheckedOptions(facetId, checkedOptionsMap, { procedureId }) {
    let checkedOptions = checkedOptionsMap[facetId];

    if (!checkedOptions && facetId === 'procedures') {
        checkedOptions = new Set([procedureId]);
    }

    return checkedOptions;
}

function getFacetChipText(displayName, appliedOptions = [], options = []) {
    if (appliedOptions.length === 0) {
        return displayName.toLowerCase();
    } else if (appliedOptions.length === 1) {
        const appliedOption = find(options, { optionId: appliedOptions[0] });
        return get(appliedOption, 'displayName', displayName);
    } else {
        return pluralize(`${appliedOptions.length} ${displayName}`).toLowerCase();
    }
}

function pluralize(text) {
    if (text.slice(-1) !== 's') {
        return `${text}s`;
    } else {
        return text;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Facet);
